
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { amountFormatUse, getToken, utc_local } from '../../../helpers/Helper';
import { del } from '../../../helpers/api_helper';
import { POST_PAYMENT_LIST, DELETE_PAYMENT } from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import ReactDOM from 'react-dom/client';
import useMounted from '../../../hooks/useMounted';
import { useTranslation } from 'react-i18next';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";



const PaymentList = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [paymentId, SetPaymentId] = useState(0);


    useMounted(() => {
        getList()
    })

    const getList = () => {
        const tableElement = $('#dataTableExample');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[0, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [7] },
                    { "targets": 0, "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';

                    $.ajax({
                        "url": POST_PAYMENT_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "error": function (xhr, status, error) {
                            if (xhr.status === 401) {
                                navigate("/logout");
                            }
                        },
                        "success": callback
                    });
                },
                "columns": [
                    { "data": "paymentId" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {utc_local(data.date, 'ddd, DD/MM/YYYY')}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>E-{data.employeeId}</>)
                        }
                    },
                    { "data": "name" },
                    { "data": "paymentType" },
                    { "data": "paymentMethod" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>{amountFormatUse(data.amount)}</>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <button className="btn btn-sm text-primary mr-2" onClick={() => { navigate('/payments/edit/' + data.paymentId); }} ><i className="bx bx-edit"></i></button>
                                <button className="btn btn-sm text-danger" onClick={() => { SetPaymentId(data.paymentId); }} data-bs-toggle="modal" data-bs-target="#deleteModal" ><i className="bx bx-trash-alt align-middle"></i></button>
                            </>)
                        }
                    },
                ]
            });
        }
    }

    // remove user role
    const remove_row = async () => {
        var res_data = await del(DELETE_PAYMENT + "?paymentId=" + paymentId);
        if (res_data.status) {
            toast(res_data.message);
            getList();
        } else {
            toast.error(res_data.message);
        }
    }

    return (
        <>
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-8'>
                                    <h5 className='mt-1'>{t('payment.list.title')}</h5>
                                </div>
                                <div className='col-4 text-right'>
                                    <Link to='/payments/add' className='btn btn-sm btn-primary'>+ {t('add')}</Link>
                                </div>
                            </div>
                            <hr />
                            <div className='table-responsive text-nowrap'>
                                <table id="dataTableExample" className="table table-striped">
                                    <thead>
                                        <tr>
                                            <td>Id</td>
                                            <td>{t('payment.list.date')}</td>
                                            <td>{t('payment.list.employeeId')}</td>
                                            <td>{t('payment.list.employeeName')}</td>
                                            <td>{t('payment.list.paymentType')}</td>
                                            <td>{t('payment.list.paymentMethod')}</td>
                                            <td>{t('payment.list.amount')}</td>
                                            <td>{t('payment.list.action')}</td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{t('delete.title')}</h5>
                            <button type="button" className="btn btn-sm close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>{t('delete.message')}</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">{t('delete.no')}</button>
                            <button onClick={remove_row.bind(this)} data-bs-dismiss="modal" className="btn btn-primary">{t('delete.yes')}</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PaymentList;